
import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";

import { IRLSidepanelPreviewItemComparer } from "./sidepanel-preview-item-comparers";
import { RLSidepanelPreviewItemController } from "./sidepanel-preview-item";
import { EntityService } from "../services/entity-service";
import { NotifyService } from "../services/notify-service";
import { UsageService } from "../services/usage-service";
import { RLSidepanelController } from "./sidepanel";
// -------- rl-sidepanel-previews -------------------------------------------------

export interface IRLSidepanelPreviewsScope extends ng.IScope {
	previewItemComparer: IRLSidepanelPreviewItemComparer;
}

export function RLSidepanelPreviews(): ng.IDirective {
	return {
		restrict: 'EA',
		template: require("/assets/app/templates/sidepanel-previews.html"),
		bindToController: {
		},
		scope: true,
		controller: RLSidepanelPreviewsController,
		controllerAs: 'sppVM',
		transclude: true,
		require: ["rlSidepanelPreviews", "^rlSidepanel"],
		link: (scope: IRLSidepanelPreviewsScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: any[]) => {

			var sidepanelPreviewsController: RLSidepanelPreviewsController = controllers[0];
			var sidepanelController: RLSidepanelController = controllers[1];

			sidepanelPreviewsController.sidepanelController = sidepanelController;

			return;
		}
	}
}

export class RLSidepanelPreviewsController {
	static $inject = ["$window", "$scope", "$rootScope", "$element", "$timeout",
		"entityService", "notifyService", "usageService"];

	private entityPreviewItems: RLSidepanelPreviewItemController[] = [];

	public sidepanelController: RLSidepanelController;

	constructor(
		private $window: ng.IWindowService,
		private $scope: IRLSidepanelPreviewsScope,
		private $rootScope: ng.IRootScopeService,
		private $element: ng.IAugmentedJQuery,
		private $timeout: ng.ITimeoutService,
		private entityService: EntityService,
		private notifyService: NotifyService,
		private usageService: UsageService) {

		$scope.$watch(() => this.selectedEntity, (newValue: any, oldValue: any) => {
			if (newValue != null) {
				this.ProcessEntitySelected(newValue);
				this.selectedEntity = undefined;
			}
		});

		$rootScope.$on(Consts.Events.ViewEntity, (event, entityID: string) => {
			this.notifyService.startProgress();
			this.entityService.getEntity(entityID)
				.then((res) => {
					this.ProcessEntitySelected(res);
				})
				.finally(() => {
					this.notifyService.endProgress();

				});
		});

		$rootScope.$on(Consts.Events.ViewEntityRelationshipPair, (event, entity: Models.IUsageRelationshipPair) => {
			this.selectedEntity = entity;
		});

		this.Init();
	}

	Init() {
		return;
	}

	public get entities(): any[] { return this.sidepanelController.previewEntities; }
	public set entities(newval: any[]) { this.sidepanelController.previewEntities = newval; }  // do we need a setter?

	public get selectedEntity(): any { return this.sidepanelController.selectedEntity; }
	public set selectedEntity(newval: any) { this.sidepanelController.selectedEntity = newval; }

	public get shouldDisableCollapseAll(): boolean {
		return this.entityPreviewItems.filter(itm => !itm.IsCollapsed).length === 0;
	}

	public get previewItemComparer(): IRLSidepanelPreviewItemComparer {
		return (this.sidepanelController != null && this.sidepanelController.previewItemComparer != null)
			? this.sidepanelController.previewItemComparer
			: null;
	}

	public RegisterElementForEntity(controller: RLSidepanelPreviewItemController) {
		var alreadyExists: boolean = _.any(this.entityPreviewItems, itm => this.previewItemComparer.IsSameItem(itm.entity, controller.entity));		
		this.$rootScope.$broadcast(Consts.Events.RefreshViewEntity, controller.entity.attachmentID != undefined ? controller.entity.attachmentID : controller.entity.record.id);

		if (alreadyExists) {
			this.RegisterControllerForExistingEntity(controller);
		}
		else {
			this.RegisterControllerForNewEntity(controller);
		}

		return;
	}

	private RegisterControllerForExistingEntity(controller: RLSidepanelPreviewItemController) {

		var existingIndex: number = _.findIndex(this.entityPreviewItems, itm => this.previewItemComparer.IsSameItem(itm.entity, controller.entity));
		var existingController: RLSidepanelPreviewItemController = this.entityPreviewItems[existingIndex];

		var shouldCollapse: boolean = (existingController != null) && existingController.IsCollapsed;

		this.entityPreviewItems[existingIndex] = controller;

		if (shouldCollapse) {
			controller.AutoHide();
		}

		controller.element.removeClass("initial");

		return;
	}

	private RegisterControllerForNewEntity(controller: RLSidepanelPreviewItemController) {

		this.entityPreviewItems.push(controller);

		this.AutoHideOtherPanels(controller.entity);

		if (this.entityPreviewItems.length > 1) {
			this.$timeout(() => { controller.ScrollIntoView(360, () => controller.element.removeClass("initial")); }, 120);
		}
		else {
			controller.element.removeClass("initial");
		}

		return;
	}

	public CollapseAll() {
		this.entityPreviewItems.forEach(itm => itm.Collapse());
		return;
	}

	public CollapseAllBut(entity: any) {
		this.entityPreviewItems.forEach((itm) => {
			if (itm.entity != entity) {
				itm.Collapse();
			}
		});
		return;
	}

	public CloseAllPreviews() {
		this.$rootScope.$broadcast(Consts.Events.RefreshViewEntity, "");		
		this.entities = [];
		this.entityPreviewItems = [];
	}

	public ClosePreview(entity: any) {
		this.entities = _.reject(this.entities, ent => this.IsSamePreviewItem(ent, entity));
		this.entityPreviewItems = _.reject(this.entityPreviewItems, itm => this.IsSamePreviewItem(itm.entity, entity));
	}

	private ProcessEntitySelected(entity: any) {
		var existingEntity: any = _.find(this.entities, ent => this.IsSamePreviewItem(ent, entity));

		if (existingEntity) {
			// update: sidepanel -> previewEntities
			if (!_.isUndefined(entity.assetRels) && !_.isUndefined(existingEntity.assetRels) && (entity.assetRels.length > 0 || existingEntity.assetRels.length > 0)) {
				existingEntity.assetRels = entity.assetRels;
			}
			if (!_.isUndefined(entity.projectRels) && !_.isUndefined(existingEntity.projectRels) && (entity.projectRels.length > 0 || existingEntity.projectRels.length > 0)) {
				existingEntity.projectRels = entity.projectRels;
			}
			if (!_.isUndefined(entity.contactRels) && !_.isUndefined(existingEntity.contactRels) && (entity.contactRels.length > 0 || existingEntity.contactRels.length > 0)) {
				existingEntity.contactRels = entity.contactRels;
			}
			if (!_.isUndefined(entity.mockRels) && !_.isUndefined(existingEntity.mockRels) && (entity.mockRels.length > 0 || existingEntity.mockRels.length > 0)) {
				existingEntity.mockRels = entity.mockRels;
			}
			existingEntity.charDataCollection = entity.charDataCollection;
			existingEntity.record = entity.record;

			var controller: RLSidepanelPreviewItemController = _.find(this.entityPreviewItems, itm => this.IsSamePreviewItem(itm.entity, existingEntity));
			if (controller) {
				if (controller.IsCollapsed) {
					this.CollapseAllBut(existingEntity);
					controller.Expand();
					this.$timeout(() => { controller.ScrollIntoView(340); });
				}
				else {  // already open, redo initial transition
					this.CollapseAll();
				}
			}
		}
		else {
			var newValue = this.entities.slice();
			newValue.push(entity);

			this.$timeout(() => {
				this.entities = newValue;
			});
		}

		return;
	}

	private AutoHideOtherPanels(entity: any) {

		this.entityPreviewItems
			.filter(itm => !this.IsSamePreviewItem(itm.entity, entity))
			.forEach(itm =>
				itm.AutoHide()
			);
	}

	private IsSamePreviewItem(item: any, otherItem: any): boolean {

		if (this.previewItemComparer) {
			return this.previewItemComparer.IsSameItem(item, otherItem);
		}

		return (item === otherItem);
	}

	private RefreshPreviewItems() {
		this.entities.forEach((entity: Models.IEntityCharDataPair, i) => {
			if (entity.record) {
				this.entityService.getEntity(entity.record.id)
					.then((result) => {
						this.entities[i] = result;
						//(<Models.IEntityCharDataPair>this.entities[i]).charDataCollection = result.charDataCollection;
						//(<Models.IEntityCharDataPair>this.entities[i]).record = result.record
					});
			}
		})
	}
}
